import { SurveyMessages, TranslationSurveyMessages } from "../interfaces";

export const messages: TranslationSurveyMessages = {
  [SurveyMessages.createSurveySuccess]: "Survey cadastrada com sucesso",
  [SurveyMessages.createSurveyError]: "Falha ao criar nova survey"
};
